// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"purchaseToggleCell_ellipsis__1Ia9K"};